import styled from 'styled-components';

export const Grid = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 1rem;
	min-height: calc(106vh - 55.78px);
	background: #4e5b59;
	color: #f5f5f1;
	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 1rem;
	}

	.title {
		margin: auto;
		justify-content: center;
		text-align: left;
		align-items: center;
		padding: 5rem;
		padding-right: 6rem;
		font-size: 1.8rem;
		line-height: 3rem;
		word-spacing: 0.5rem;
		@media (max-width: 768px) {
			padding: 2rem;
		}
	}

	.text {
		margin: auto 0;
		padding: 5rem;
		justify-content: left;
		text-align: left;
		align-items: left;
		padding-right: 6rem;
		font-size: 1.2rem;
		line-height: 2rem;
		word-spacing: 0.2rem;
		.info {
			font-size: 1.2rem;
			padding: 1rem 0;
		}
		.artist {
			padding: 1rem 0;
			line-height: 1;
		}
		.navn {
			font-size: 1.3rem;
		}
		.instrument {
			font-size: 0.9rem;
			text-transform: uppercase;
		}
		.om {
			font-size: 0.7rem;
			line-height: 1rem;
		}
		@media (max-width: 768px) {
			padding: 2rem;
		}
	}

	a {
		text-decoration: none;
		color: #ea3c53;
		&:hover {
			font-size: 1.25rem;
			cursor: pointer;
		}
	}
	.pic {
		min-height: calc(106vh - 55.78px);
	}
	.picss {
		min-height: calc(106vh - 55.78px);
	}
	.FormControl {
		margin: auto;
	}
	.form-control {
		font-size: 1.5rem;
		margin-bottom: 1rem;
		background: transparent;
		font-size: 1rem;
		width: 80%;
		line-height: 2.2rem;
		box-shadow: none;
		border: none;
		border-bottom: 2px solid #f5f5f1;
		color: #f5f5f1;
		outline: thin;
		::placeholder {
			color: #f5f5f1;
			padding: 1rem;
		}
		@media (max-width: 768px) {
			width: 100%;
		}
	}
	.submit {
		border: none;
		color: #4e5b59;
		background: #f5f5f1;

		padding: 0.5rem 2rem;
		margin: 1rem;
		&:hover {
			background: #ea3c53;
		}
	}

	h2 {
		font-size: 2.5rem;
		padding-bottom: 2.5rem;

		@media (max-width: 768px) {
			font-size: 1.8rem;
			&:hover {
				cursor: pointer;
			}
		}
	}
	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 1rem;
	}
	.text3 {
		position: absolute;
		bottom: 0rem;
		text-align: right;
		left: 0.5rem;
		color: #d6d2c4;
		font-size: 0.7rem;
	}
`;

export const Oss = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 1rem;
	min-height: calc(106vh - 55.78px);
	color: #4e5b59;
	background: #f5f5f1;
	h2 {
		font-size: 2.5rem;
		padding-bottom: 2.5rem;

		@media (max-width: 768px) {
			font-size: 1.8rem;
			&:hover {
				cursor: pointer;
			}
		}
	}
	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 1rem;
	}
	.pic {
		min-height: calc(106vh - 55.78px);
		@media (max-width: 768px) {
			padding: 2rem;
		}
	}
	.text {
		margin: auto;
		justify-content: center;
		text-align: left;
		align-items: center;
		padding: 5rem;
		padding-right: 6rem;
		font-size: 1.2rem;
		line-height: 2rem;
		word-spacing: 0.2rem;
		@media (max-width: 768px) {
			padding: 2rem;
		}
	}
`;

export const Triple = styled.div`
	.grid {
		display: grid;
		grid-template-columns: auto;
		grid-row-gap: 1rem;

		color: #4e5b59;
		background: #f5f5f1;
		@media (min-width: 768px) {
			grid-template-columns: 1fr 1fr 1fr;
			grid-column-gap: 1rem;
		}
	}
	.program {
		width: 80%;
	}
	p {
		padding-bottom: 1rem;
	}
	h2 {
		font-size: 2.5rem;
		padding-bottom: 2.5rem;

		@media (max-width: 768px) {
			font-size: 1.8rem;
			&:hover {
				cursor: pointer;
			}
		}
	}
	.title {
		font-size: 1.5rem;
		padding-bottom: 2rem;
	}
	margin: auto;
	justify-content: center;
	text-align: left;
	align-items: center;
	padding: 5rem;
	padding-right: 6rem;
	font-size: 1.2rem;
	line-height: 2rem;
	@media (max-width: 768px) {
		padding: 2rem;
	}
	.pic {
		height: 10rem;
		width: 11rem;
		margin: auto;
		justify-content: center;
		text-align: left;
		align-items: center;
	}
	.pic2 {
		width: 13rem;
	}
	.info {
		width: 80%;
		margin: auto;
		justify-content: center;
		text-align: left;
		align-items: center;
	}
`;

export const KarusellWrapper = styled.section`
	@media (max-width: 768px) {
		padding: 0;
	}
	.blur {
		height: 20rem;
		padding-top: 2rem;

		@media (min-width: 768px) {
			min-height: calc(106vh - 55.78px);
		}
	}
`;

export const Partnere = styled.div`
	margin: auto;
	justify-content: center;
	text-align: left;
	align-items: left;
	padding-bottom: 10rem;
	.grid {
		display: grid;
		grid-template-columns: auto;
		grid-row-gap: 1rem;
		color: #4e5b59;
		background: #f5f5f1;
		@media (min-width: 768px) {
			grid-template-columns: 1fr 1fr 1fr 1fr;
			grid-column-gap: 1rem;
		}
	}
	.DK {
		height: 6.55rem;
		width: 8rem;
		&:hover {
			height: 6.6rem;
			width: 8.2rem;
		}
	}
	.HF {
		height: 3.95rem;
		width: 14rem;
		&:hover {
			height: 4rem;
			width: 14.3rem;
		}
	}
	.VM {
		height: 2rem;
		width: 14rem;
		&:hover {
			height: 2.2rem;
			width: 14.4rem;
		}
	}
	.N {
		height: 2rem;
		width: 9rem;
		&:hover {
			height: 2.2rem;
			width: 9.4rem;
		}
	}
	.pic {
		margin: 2rem auto;
		justify-content: center;
		text-align: left;
		align-items: left;
		&:hover {
			cursor: pointer;
		}
	}
	h2 {
		font-size: 2.5rem;
		padding-bottom: 2.5rem;
		margin: auto;
		justify-content: center;
		text-align: left;
		align-items: center;
		padding: 5rem;
		padding-right: 6rem;

		@media (max-width: 768px) {
			font-size: 1.8rem;
			&:hover {
				cursor: pointer;
			}
		}
	}
`;
